import { Breakpoint, DialogTitle, Stack } from "@mui/material"
import { ReactElement } from "react"

import ProvideMpanManuallyForm from "./provideMpanManuallyForm"
import { IUseScreenSize, useScreenSize } from "../../../hooks/useScreenSize"
import { GRID_SPACING } from "../../../themes/defaultThemeParams"
import AppDialog from "../../dialog/appDialog"
import { AppCardHeader } from "../../surfaces/appCard"

interface IProvideMpanManuallyProps {
    isOpen: boolean
    submitApplicationManualMpan: (manuallyProvidedMpan: string) => void
}

const ProvideMpanManually = ({
    isOpen,
    submitApplicationManualMpan,
}: IProvideMpanManuallyProps): ReactElement => {
    const screenSize = useScreenSize()

    const { isMob, isTabletOrMob } = screenSize

    const getUpperBoundBreakPointFromScreenSize = (
        size: IUseScreenSize
    ): Breakpoint => {
        if (size.isMob) {
            return "sm"
        }

        if (size.isTablet) {
            return "md"
        }

        if (!size.isTabletOrMob && !size.isLg) {
            return "lg"
        }

        if (size.isLg || size.isXl) {
            return "xl"
        }

        return "md"
    }

    const upperBoundBreakpoint: Breakpoint =
        getUpperBoundBreakPointFromScreenSize(screenSize)

    const marginMapping: Record<Breakpoint, string> = {
        xs: "0px",
        sm: "0px",
        md: "15%",
        lg: "25%",
        xl: "30%",
    }

    const stackMargin = marginMapping[upperBoundBreakpoint]
    const titleTypographyProps = isMob
        ? undefined
        : {
              fontSize: 38,
          }

    const subheaderTypographyProps = isMob
        ? undefined
        : {
              mt: 2,
              fontSize: 18,
          }

    return (
        <AppDialog
            sx={{
                justifyContent: "center",
            }}
            isOpen={isOpen}
            isFullscreen
        >
            <Stack
                alignItems="center"
                textAlign="center"
                marginX={stackMargin}
                marginY={isMob ? 0 : GRID_SPACING * 2}
                spacing={isMob ? 0 : GRID_SPACING * 2}
            >
                <DialogTitle mt={isTabletOrMob ? 3 : 4}>
                    <AppCardHeader
                        title="We were unable to find an MPAN for this application"
                        subheader={`Unfortunately, we were unable to locate an MPAN for 
                        this address. If you are unable to provide this at this time,
                        this application will be saved within your drafts. Once you 
                        know the MPAN you can return to this application and provide it.`}
                        titleTypographyProps={{
                            color: "text.primary",
                            ...titleTypographyProps,
                        }}
                        subheaderTypographyProps={subheaderTypographyProps}
                    />
                </DialogTitle>
            </Stack>
            <ProvideMpanManuallyForm
                marginX={stackMargin}
                submitApplicationManualMpan={submitApplicationManualMpan}
            />
        </AppDialog>
    )
}

export default ProvideMpanManually
